module.exports = require("ngx-loading");